import React, { useRef } from "react";

import Header from "../../components/Header";
import "../../assets/css/global.css";
import "../../assets/css/quiz.css";
import QuizC from "../../components/Quiz";

import FooterSection from "../../components/FooterSection";

import { StaticImage } from "gatsby-plugin-image";
import { navigate } from "gatsby";
import { Helmet } from "react-helmet";

const Quiz = ({ location }) => {
  const scrollRef = useRef();

  return (
    <main>
      <Helmet>
        <title>HBOC Test - Strand</title>
      </Helmet>
      <Header
        scrollRef={scrollRef}
        hideOrderButton={
          location.pathname === "/calculators/breast-cancer-risk-calculator"
        }
      />
      {/* <button
        type="button"
        className="default__btn fixed__element orderatest"
        id="orderatest"
        onClick={() => {
          navigate("/");
          scrollRef.current.scrollIntoView({ behavior: "smooth" });
        }}
      >
        Order a test
      </button> */}
      <QuizC />

      <FooterSection />
      <div className="floatButtonContainer1">
        <a
          // className="shadow"
          aria-current="page"
          href="https://wa.me/+919980448044"
          target="_blank"
          className="whatsapp"
          id="whatsapp"
        >
          <StaticImage
            src="../../assets/images/wa-float.png"
            // objectFit="contain"
            className="float__btn"
            quality={100}
          />
        </a>
      </div>
    </main>
  );
};

export default Quiz;
